import React, { useEffect, useState } from 'react'
import useAuth from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { ENDPOINT_ACCOUNT_REFRESH_TOKEN } from '../Config';

function SubscribeSuccess() {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const RETRY_AFTER_SECONDS = 5;
    const [hasBillingProfile, setHasBillingProfile] = useState(false);
    const [retryAfter, setRetryAfter] = useState(RETRY_AFTER_SECONDS);


    useEffect(() => {
        let retryInterval = null;
        const ping = async () => {
            try {
                const response = await axios.get(ENDPOINT_ACCOUNT_REFRESH_TOKEN, {
                    withCredentials: true
                });
                setAuth(response.data);
                const billingProfileId = response?.data?.account?.VideoBoostClient?.billingProfileId;
                setHasBillingProfile(billingProfileId);
                if (!billingProfileId) {
                    retryInterval = setInterval(() => {
                        setRetryAfter(prev => {
                            if (prev <= 0) {
                                clearInterval(retryInterval);
                                ping();
                                return RETRY_AFTER_SECONDS;
                            }
                            return prev - 1;
                        });
                    }, 1000);
                } else {
                    navigate(`/`);
                }
            } catch (error) {

            }
        }
        ping();
        return () => {
            if (retryInterval) {
                clearInterval(retryInterval);
            }
        };
    }, []);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center mt-5">
            <div className="card bg-light shadow-sm w-100" style={{ maxWidth: '30rem' }}>
                <div className="card-body d-flex justify-content-between align-items-center">
                    {!hasBillingProfile &&
                        <>
                            <h5 className="card-title text-info m-0">Updating Your Account...</h5>
                            <div className="spinner-border spinner-border-sm">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </>
                    }
                </div>
            </div>

        </div>
    )
}

export default SubscribeSuccess
